import React from 'react'
import { useRouter } from 'next/router'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// resources
import PreviewImage from 'assets/images/studio-preview-image-user.png'

// styles
import styles from './index.module.scss'

const FeaturedShopCardMobile = ({ data }) => {
  const router = useRouter()

  const handleVisitShop = () => {
    if (data?.creatorUsername) {
      router.push(`/${data.creatorUsername}/merch`)
    }
  }

  const handleProductClick = (item, e) => {
    e.stopPropagation()
    if (item?.itemId && data?.creatorUsername) {
      router.push(`/${data.creatorUsername}/merch/${item.itemId}`)
    }
  }

  // Extract banner image, profile picture, store name, description, and products
  const bannerImage = data?.creatorStoreUrl?.length > 0 ? data.creatorStoreUrl : PreviewImage.src
  const profilePicture = data?.creatorImage || ''
  const username = data?.creatorUsername || data?.username || '@username'
  const products = data?.items?.slice(0, 4) || []

  return (
    <div className={styles.container}>
      {/* Top Section: Shop Header/Profile */}
      <div className={styles.topSection}>
        <div>
          <div className="w-full aspect-[2/1] overflow-hidden rounded-[15px]">
            <ImageWithFoster src={bannerImage} showPlaceHolder={true} />
          </div>

          <div className="mt-[-18px] ml-[8px] pb-[16px]">
            <div className={styles.profilePictureContainer}>
              {profilePicture ? (
                <div className={styles.profilePictureWrapper}>
                  <ImageWithFoster src={profilePicture} className={styles.profilePicture} showPlaceHolder={true} />
                </div>
              ) : (
                <div className={styles.profilePlaceholder} />
              )}
              <button className={styles.visitShopButton} onClick={handleVisitShop}>
                Visit Shop
              </button>
            </div>
            <div className={styles.usernameSection}>
              <span className={styles.username}>@{username}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section: Featured Products */}
      <div className={styles.bottomSection}>
        <div className={styles.productsGrid}>
          {products.map((product, index) => (
            <div key={index} className={styles.productCard} onClick={e => handleProductClick(product, e)}>
              <ImageWithFoster
                src={product?.itemUrl || product?.image || ''}
                className={styles.productImage}
                showPlaceHolder={true}
              />
            </div>
          ))}
          {/* Fill empty slots if less than 4 products */}
          {Array.from({ length: Math.max(0, 4 - products.length) }).map((_, index) => (
            <div key={`empty-${index}`} className={`${styles.productCard} ${styles.emptyProduct}`} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default FeaturedShopCardMobile
